import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

interface PageThumbnailsProps {
  pdfUrl: string;
  totalPages: number;
  currentPage: number;
  onGoToPage: (page: number) => void;
}

const PageThumbnails: React.FC<PageThumbnailsProps> = ({
  pdfUrl,
  totalPages,
  currentPage,
  onGoToPage,
}) => {
  return (
    <div className="flex flex-col gap-2 p-2 overflow-auto">
      <Document file={pdfUrl} loading={null}>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
          <button
            key={pageNum}
            onClick={() => onGoToPage(pageNum)}
            className={`relative rounded-md overflow-hidden border-2 transition-colors ${
              currentPage === pageNum
                ? 'border-violet-500 shadow-md'
                : 'border-gray-200 hover:border-gray-300'
            }`}
          >
            <Page
              pageNumber={pageNum}
              width={72}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
            <span
              className={`absolute bottom-0 inset-x-0 text-center text-[10px] py-0.5 ${
                currentPage === pageNum
                  ? 'bg-violet-500 text-white'
                  : 'bg-gray-800/60 text-white'
              }`}
            >
              {pageNum}
            </span>
          </button>
        ))}
      </Document>
    </div>
  );
};

export default PageThumbnails;
